<template>
  <div class="Speakers-wrapper">
    <Head :title="$tc('header.speakers')" />
    <!-- <Foot /> -->
    <div class="Speakers-content">
      <div class="nav" v-if="cates.length > 1">
        <span
          v-for="(item, index) in cates"
          :class="[index === currentIndex && 'active']"
          :key="item.id"
          @click="changeCate(index)"
          >{{ item.name }}</span
        >
      </div>
      <speakers-list v-if="list && list.length" :guests="list"></speakers-list>
      <Empty :emptydata="emptydata" v-if="emptydata" />
    </div>
  </div>
</template>

<script>
import SpeakersList from '@/components/Speakers/List.vue'

import { mapState, mapMutations } from 'vuex'

export default {
    name: 'Speakers',
    data () {
        return {
            cates: [],
            list: [],
            currentIndex: 0,
            keyword: '',
            emptydata: null
        }
    },
    components: {
        SpeakersList
    },
    computed: {
        ...mapState(['lang'])
    },
    beforeRouteUpdate (to, from, next) {
        const lan = to.query.lan || 'zh'
        if (lan !== this.lang) {
            this.$router.push({
                path: '/',
                query: {
                    lan
                }
            })
        }
    },
    created () {
        this.getList()
    },
    mounted () {
        this.$nextTick(() => {
            this.$Common.pageShare()
        })
        this.$Common.track('load', {
            name: '嘉宾列表',
            tab: ''
        })
    },
    methods: {
        ...mapMutations(['setShowLoading']),
        getList () {
            if (this.isLoading) return
            this.isLoading = true
            this.$Api
                .getGuestList({
                    keyword: this.keyword
                })
                .then(data => {
                    if (data.categoryGuest.length) {
                        this.cates = data.categoryGuest || []
                        this.list = data.categoryGuest[0].guests || []
                        this.track()
                    }
                    !this.list.length &&
                        (this.emptydata = {
                            type: 'nodata'
                        })
                    this.setShowLoading(false)
                    this.isLoading = false
                })
                .catch(() => {
                    this.emptydata = {
                        type: 'nonetwork'
                    }
                    this.isLoading = false
                    this.setShowLoading(false)
                })
        },
        changeCate (index) {
            this.currentIndex = index
            this.list = this.cates[index].guests || []
            if (!this.list.length) {
                this.emptydata = {
                    type: 'nodata'
                }
            } else {
                this.emptydata = null
            }
            this.track()
        },
        track () {
            this.$Common.track('load', {
                name: '嘉宾列表',
                tab: this.cates[this.currentIndex].name,
                type: '嘉宾'
            })
        }
    }
}
</script>

<style lang="scss">
.Speakers-wrapper {
  font-size: 0;
  .empty-wrapper {
    height: auto;
  }
}
.Speakers-content {
  padding: 0 4.63vw;
  font-size: 0;
  .nav {
    padding-top: 7.407vw;
    margin-bottom: 0.556vw;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    span {
      font-weight: normal;
    }
  }
}
</style>
